<template>
  <div
    class="review-card-logo flex-shrink-0"
    :class="{ 'review-card-logo--watermark': isWatermark }"
    :style="logoStyle"
    aria-hidden="true"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { CommonContextStore } from 'src/types/context'
import useContextStore from 'src/store/useContextStore'
import { getMediaUrl } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/functions/getMediaUrl'

withDefaults(defineProps<{
  isWatermark?: boolean
}>(), {
  isWatermark: false,
})

const { context }: CommonContextStore = useContextStore()
const logoStyle = computed(() => {
  if (context.request.country.is_russia || !context.request.country.site_logo) {
    return undefined
  }

  const src = getMediaUrl(context.request.country.site_logo, context)

  return src ? { backgroundImage: `url(${src})` } : undefined
})
</script>

<style scoped lang="scss">
.review-card-logo {
  width: 79px;
  height: 12px;
  opacity: 0.5;
  background: center / contain no-repeat url('/static/_v1/pd/logos/ui-kit/prodoctorov-logo.svg');

  &--watermark {
    position: absolute;
    top: 4px;
    right: 0;
  }
}
</style>
